import { Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  onClick: () => void;
  icon?: string;
  symbol?: string;
  disabled?: boolean;
}

export const IconButton = ({ title, icon, onClick, symbol, disabled }: Props) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t(title)}
      componentsProps={{
        popper: {
          sx: {
            ['& .MuiTooltip-arrow']: {
              color: '#9CDFFC',
            },
            ['& .MuiTooltip-tooltip']: {
              backgroundColor: '#9CDFFC',
              color: '#000000',
              fontSize: '14px',
              padding: '14px',
              borderRadius: '8px',
            },
          },
        },
      }}
      arrow
    >
      <button
        className="btn more small h-[40px] w-[40px] rounded-[8px] !p-[6px] text-red-600"
        onClick={onClick}
        disabled={disabled}
      >
        {icon && <img src={icon} alt="icon" />}
        {symbol}
      </button>
    </Tooltip>
  );
};
